<template lang="pug">

    form.ui.form(v-on:submit.prevent='submit()')

        .ui.field
            label Gültigkeit des Hashlinks in Tagen
            .ui.fluid.action.input
                input(type="number" v-model='days' min="1")
                button.ui.right.labeled.icon.button
                    i.plus.icon
                    | Hashlink erstellen
            field-error(v-bind:validation='validation' attribute='days')

        text-field(
            ref='linkField'
            v-bind:value='link'
            v-bind:is-read-only='true'
            label='Hashlink'
            v-show="link.length > 0"
        )


</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import FieldError from '@/components/form/SmartFieldError'
    import TextField from '@/components/form/TextField'

    export default {

        components: { FieldError, TextField },

        data() {
            return {
                days: 7,
                link: ''
            }
        },

        methods: {

            persist() {
                R.composeP(

                    // Growl anzeigen
                    () => this.$growl.success('Hashlink erstellt'),

                    // Links setzen
                    link => this.link = link,

                    // Hashlink-URL erstellen
                    location => `${window.location.origin}${location}`,

                    // Location-Header aus Response lesen
                    R.path(['headers', 'location']),

                    // Model speichern
                    model => this.$store.dispatch('hashlinks/create', { model }),

                    // Model erstellen
                    expireAt => ({ expireAt, file: this.fileModel.id }),

                    // Addieren mit aktuellen Timestamp
                    R.add(Date.now()),

                    // Tage zu Millisekunden konvertieren
                    days => Promise.resolve(days * 60 * 60 * 24 * 1000)

                )(this.days).catch(e => this.$growl.fatal('Hashlink konnte nicht erstellt werden', e))
            },

            submit() {
                this.validate().then(R.when(R.equals(true), this.persist))
            },

            validate() {
                return this.$validate()
            }

        },

        props: {

            fileModel: {
                type: Object,
                required: true
            }

        },

        validators: {

            days(value) {
                return Validator.value(R.defaultTo('', value))
                    .required('Darf nicht leer sein. Bitte einen gültigen Wert angeben')
            }

        },

    }

</script>
